import { AUTHORIZED_INS, DEFAULT_INS } from "./api";

const AUTH_API = {
  login: (data) => DEFAULT_INS.post("/login", data),

  unlogin: () => AUTHORIZED_INS.post("/logout"),
};

export default AUTH_API;
